// notification
const Listnotification = () => import('@/views/notification')
const Formnotification = () => import('@/views/notification/form')

export default {
    path: 'notification',
    redirect: '/notification',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'notification',
            component: Listnotification,
            meta: {
                link: 'notification',
                breadcrumb: [
                    { title: 'Notification', active: true },
                ],
                pageTitle: 'Notification'
            }
        },
        {
            path: 'add',
            name: 'addnotification',
            component: Formnotification,
            meta: {
                link: 'notification',
                breadcrumb: [
                    { title: 'Notification', url: '/notification' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Notification'
            }
        },
        {
            path: 'edit/:id',
            name: 'editnotification',
            component: Formnotification,
            meta: {
                link: 'notification',
                breadcrumb: [
                    { title: 'Notification', url: '/notification' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Notification'
            }
        },
    ]
}